import { render, staticRenderFns } from "./forgot_password_form.vue?vue&type=template&id=8b6746fe&lang=pug"
import script from "./forgot_password_form.vue?vue&type=script&lang=js"
export * from "./forgot_password_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports